/**
 * ResetPasswordModal.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import axios from 'axios';
import * as Icons from '../../../sharedComponents/icons/Icons';

import ResetPasswordForm from './ResetPasswordForm';
import ResetPasswordConfirmation from './ResetPasswordConfirmation';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    signIn: PropTypes.func
};

const defaultProps = {
    isOpen: false,
    closeModal: () => { },
    signIn: () => { }
};

export default class ResetPasswordModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            inputError: false,
            serverError: false,
            completed: false
        };

        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.sendResetPasswordEmail = this.sendResetPasswordEmail.bind(this);
        this.confirmEmail = this.confirmEmail.bind(this);
    }

    afterOpenModal() {
        this.setState({
            email: '',
            inputError: false,
            serverError: false,
            completed: false
        });
    }

    emailTextChange(event) {
        this.setState({ email: event.target.value });
    }

    sendResetPasswordEmail() {
        // TODO: Validation
        if (this.state.email.length < 1) {
            this.setState({
                inputError: true,
                serverError: false
            });
        }
        else {
            const url = `${process.env.API}/accounts/passwordreset?email=${encodeURIComponent(this.state.email)}`;

            axios.post(url)
                .then(() => {
                    this.setState({
                        inputError: false,
                        serverError: false,
                        completed: true
                    });
                })
                .catch(() => {
                    this.setState({
                        inputError: false,
                        serverError: true
                    });
                });
        }
    }

    confirmEmail(account) {
        this.setState({
            email: account.email
        }, () => {
            this.sendResetPasswordEmail();
        });
    }

    render() {
        let errorText = null;

        if (this.state.inputError) {
            errorText = 'All fields are required.';
        }

        if (this.state.serverError) {
            errorText = 'An error has occurred, please try again later.';
        }

        let content = null;

        if (this.state.completed) {
            content = (
                <ResetPasswordConfirmation
                    email={this.state.email}
                    sendResetPasswordEmail={this.sendResetPasswordEmail} />
            );
        }
        else {
            content = (
                <ResetPasswordForm
                    errorText={errorText}
                    signIn={this.props.signIn}
                    confirmEmail={this.confirmEmail} />
            );
        }

        return (
            <Modal
                role="complementary"
                isOpen={this.props.isOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.props.closeModal}
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md rec-acct-modal rec-acct-reset-modal',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                contentLabel="Reset Password"
                ariaHideApp={false}>
                <div className="rec-modal-content-wrap">
                    <button className="rec-close-modal" onClick={this.props.closeModal}>
                        <Icons.IconClose />
                    </button>
                    {content}
                </div>
            </Modal>
        );
    }
}

ResetPasswordModal.propTypes = propTypes;
ResetPasswordModal.defaultProps = defaultProps;
